// extracted by mini-css-extract-plugin
export var socialLink = "social-module--socialLink--Idwed";
export var socialMenu = "social-module--socialMenu--w9MxF";